import * as React from "react";
import { useFormikContext } from "formik";
import { Input } from "components/bootstrap";
import { FormikFormGroup } from "components/common";
const SynchronizeGroupsCheckbox = ({ disabled }) => {
  const { values, setErrors } = useFormikContext();
  const _onChange = (event) => {
    if (values.synchronizeGroups && !event.target.checked) {
      setErrors({});
    }
  };
  return /* @__PURE__ */ React.createElement(
    Input,
    {
      label: "Enable Group Synchronization",
      id: "synchronize-groups-checkbox",
      disabled,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    },
    /* @__PURE__ */ React.createElement(
      FormikFormGroup,
      {
        label: "Synchronize Groups",
        onChange: _onChange,
        disabled,
        wrapperClassName: "col-sm-12",
        name: "synchronizeGroups",
        help: "Select this option if you want to import groups as teams",
        type: "checkbox"
      }
    )
  );
};
export default SynchronizeGroupsCheckbox;
